<div class="flex w-full flex-col gap-2">
	<app-order-quantity-input />
	<ui-input
		appKeyboard
		label="قیمت"
		labelPosition="inside"
		[class]="priceFieldClasses()"
		[error]="priceError()"
		[step]="10"
		[stepMode]="priceStepMode()"
		[stepValue]="priceStepValue()"
		[readOnly]="true"
		[ariaDisabled]="priceLocked()"
		[keyboardEnabled]="!priceLocked()"
		[attr.aria-invalid]="priceError()"
		[ngModel]="formattedPrice()"
		(ngModelChange)="onPriceChange($event)">
		<div class="flex items-center gap-0.5 -ms-1.5" dir="ltr">
			<div class="inline-flex min-w-16 flex-col items-stretch gap-0.5 ps-px">
				<div
					role="button"
					class="flex h-4.5 cursor-pointer items-center justify-start gap-0.5 rounded-sm rounded-tl-md bg-gray-950/10 px-px text-2.75 font-medium leading-none text-gray-700"
					[attr.aria-label]="'حداکثر قیمت مجاز'"
					(click)="setMaxPrice()">
					<ui-icon
						class="inline-flex shrink-0 items-center justify-center"
						width="16"
						height="16"
						iconName="chevron-up"
						color="text-gray-500" />
					@if (maxPrice() !== undefined) {
						<span class="inline-flex items-center leading-none whitespace-nowrap">{{
							maxPriceLabel()
						}}</span>
					}
				</div>
				<div
					role="button"
					class="flex h-4.5 cursor-pointer items-center justify-start gap-0.5 rounded-sm rounded-bl-md bg-gray-950/10 px-px text-2.75 font-medium leading-none text-gray-700"
					[attr.aria-label]="'حداقل قیمت مجاز'"
					(click)="setMinPrice()">
					<ui-icon
						class="inline-flex shrink-0 items-center justify-center"
						width="16"
						height="16"
						iconName="chevron-down"
						color="text-gray-500" />
					@if (minPrice() !== undefined) {
						<span class="inline-flex items-center leading-none whitespace-nowrap">{{
							minPriceLabel()
						}}</span>
					}
				</div>
			</div>
			<ui-button
				variant="ghost"
				size="md"
				iconOnly
				label="قفل قیمت"
				class="mx-0.5 flex h-9.5 w-9.5 items-center justify-center rounded-lg"
				[ariaPressed]="priceLocked()"
				[class.bg-gray-500/10]="priceLocked()"
				(click)="toggleLock()">
				<ui-icon [iconName]="lockPriceIcon()" />
			</ui-button>
		</div>
	</ui-input>
</div>
